import type { ApolloClient } from '@apollo/client';
import type { User } from 'oidc-client-ts';
import { useCurrentContextStore } from '../hooks/store/useCurrentContextStore';
import { useThemeStore } from '../hooks/store/useThemeStore';
import { DOCTOR_THEME_QUERY } from '../hooks/useDoctorTheme.gql';
import { hasAnyRelevantRole } from '../utils/user';

// network-only puts the theme in the cache, so DynamicConfigProvider finds it there instead of falling back
export const switchToZuweiser = async (doctorId: string, client: ApolloClient, user: User | null | undefined) => {
  const doctorTheme = hasAnyRelevantRole(user)
    ? await client
        .query({ query: DOCTOR_THEME_QUERY, variables: { doctorId }, fetchPolicy: 'network-only' })
        .then(({ data }) => data?.doctor?.theme)
        .catch(() => null)
    : null;
  useCurrentContextStore.getState().setCurrentDoctorId(doctorId);
  if (doctorTheme) {
    useThemeStore.getState().setTheme(doctorTheme, false);
  }
};
